export default __webpack_public_path__ + "images/BTQ.4e5abe7.png";